/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1BannerBanneridLangsIdMutationRequest,
  PutApiV1BannerBanneridLangsIdMutationResponse,
  PutApiV1BannerBanneridLangsIdPathParams,
  PutApiV1BannerBanneridLangsId400,
  PutApiV1BannerBanneridLangsId401,
  PutApiV1BannerBanneridLangsId404,
  PutApiV1BannerBanneridLangsId500,
} from "../../types/bannerIdiomasController/PutApiV1BannerBanneridLangsId.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPutApiV1BannerBanneridLangsIdUrl(
  bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"],
  id: PutApiV1BannerBanneridLangsIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/banner/${bannerId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza os dados de uma tradução (idioma) de banner (multipart/form-data). **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs/:id}
 */
export async function putApiV1BannerBanneridLangsId(
  bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"],
  id: PutApiV1BannerBanneridLangsIdPathParams["id"],
  data?: PutApiV1BannerBanneridLangsIdMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1BannerBanneridLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PutApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerBanneridLangsId400
      | PutApiV1BannerBanneridLangsId401
      | PutApiV1BannerBanneridLangsId404
      | PutApiV1BannerBanneridLangsId500
    >,
    PutApiV1BannerBanneridLangsIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1BannerBanneridLangsIdUrl(bannerId, id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
